import React, {useImperativeHandle, useState, forwardRef, useEffect} from "react";
import { displayHtml } from "@app/utils/util";

/* Props
*  label        : string
*  inputId      : string, to identify input and link it to its label
*  isReadOnly   : bool, set to true if input shouldn't be modified
*/
const InputCheckbox = forwardRef( function InputCheckbox({
    label, inputId, isRequired, isReadOnly=false, defaultValue=false, callbackOnChange, inputValue
}, ref) {
    const [value, setValue] = useState(defaultValue);
    const [isDisplayErrors, setIsDisplayErrors] = useState(false);

    useImperativeHandle(ref, ()=>({
        getValue() {
            return value;
        },
        hasErrors() {
            return hasErrors();
        },
        displayErrors() {
            setIsDisplayErrors(false)
            if (hasErrors()) {
                setIsDisplayErrors(true)
            }
        },
        setValue(val) {
            setValue(val);
        },
        resetValue() {
            setValue(false);
            setIsDisplayErrors(false);
        }
    }));

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    /**
     * Check if there is an error in this input
     */
    function hasErrors() {
        return (
            isRequired && value == ""
        );
    }

    function handleChange(event) {
        setValue(event.target.checked);
        
        if (callbackOnChange) {
            callbackOnChange(event.target.value)
        }
    }

    let mandatoryMark = isRequired ? "*" : "";

    function displayErrorMessage() {
        if (isDisplayErrors) {
            return (
                <p className="input-error-message">Ce champ est obligatoire</p>
            )
        }
    }

    return (
        <div className="input-checkbox input-group mb-3">
            <input
                name={inputId}
                className="form-check-input"
                type="checkbox"
                required={true}
                disabled={isReadOnly}
                checked={value}
                onChange={handleChange}
                value={inputValue}
            /> 
            <label className="form-check-label custom-form-label ms-2" dangerouslySetInnerHTML={displayHtml(label + " " + mandatoryMark)}></label>
            {displayErrorMessage()}
        </div>
    )
})

export default InputCheckbox;